import styles from "./FeatureTitleAndDevDays.module.css";

// react
import React from "react";

// context
import { useContext } from "react";
import { MyContext } from "components/RoleContext";
import { Role } from "tools/Enums";

// Reusable component to show title, dev time, custom and beta of a feature
// Prop -> feature object
export default function FeatureTitle(props) {
	const { role } = useContext(MyContext);
	return (
		<div className={styles.container}>
			<div title={props.feature.title} className={styles.title}>
				{props.feature.title}
			</div>

			{/* It only shows dev time and custom properties if you are an admin */}
			{role === Role.Admin && props.feature.estDevTimeInDays !== 0 && (
				<div className={styles.estDevTimeInDays}>{props.feature.estDevTimeInDays}d</div>
			)}
			{props.feature.custom && <span className={styles.custom}>CUSTOM</span>}
			{props.feature.beta && <span className={styles.beta}>BETA</span>}
		</div>
	);
}
